import { EntityService } from './EntityService';
import { IEntity } from '../types';

export class DepartmentalObjectiveService extends EntityService<IEntity> {
    constructor() {
        super(`/DepartmentalObjectives`);
    }
}